import * as React from 'react';
import MuiLink from '@material-ui/core/Link';
import { Link as GatsbyLink } from 'gatsby-theme-material-ui';

const Link = props => {
  const href = props.href || props.to;
  if (href.startsWith('http')) {
    return <MuiLink {...props} />;
  } else {
    console.log('gatsby');
    return <GatsbyLink to={href} {...props} />
  }
}

export default Link;
